import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class RecommendationService {

  constructor(
    private http: HttpClient
  ) { }

  getRecommendationFileList(agentId) {
    return this.http.get(environment.va_training_api + "recommendation/" + agentId + "/get")
  }

  uploadRecommendationFile(agentId, file) {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post(environment.va_training_api + "recommendation/" + agentId + "/upload", formData, {
      headers: new HttpHeaders().set('Content-Type', 'multipart/form-data'),
    })
  }
  trainRecommendation(agentId, recommendationId, trainType) {
    return this.http.post(environment.va_training_api + "recommendation/" + agentId + "/" + recommendationId + "/train", {trainType})
  }
  deleteRecommendation(agentId, recommendationId) {
    return this.http.delete(environment.va_training_api + "recommendation/" + agentId + "/" + recommendationId + "/delete")
  }
  selectRecommendation(agentId, recommendationId) {
    return this.http.put(environment.va_training_api + "recommendation/" + agentId + "/" + recommendationId + "/select", {})
  }
  getRuleList(agentId,limit,offset,topicSearch, featureSearch, recSearch){
    return this.http.get(environment.va_training_api + "recommendation/" + agentId + "/rules?limit=" + limit + '&offset=' + offset+'&topicSearch='+topicSearch+'&featureSearch='+featureSearch+'&recSearch='+recSearch)
  }

  saveRule(agentId,param){
    return this.http.post(environment.va_training_api + "recommendation/" + agentId + "/save",param)
  }

  deleteRule(agentId,ruleId){
    return this.http.delete(environment.va_training_api + "recommendation/" + agentId + "/" + ruleId + "/delete_rule")
  }
}
